import { createFileRoute } from "@tanstack/react-router";
import IRSNoticesIndex from "@/pages/site/IRSNoticesIndex";

export const Route = createFileRoute("/resources/irs-notices/")({
  component: () => <IRSNoticesIndex />,
});
